/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { InjectionToken } from '@angular/core';
import { MapCommand } from '../../map-command.class';

export const CLEAR_BUFFER_COMMAND = new InjectionToken<MapCommand>('CLEAR_BUFFER_COMMAND');
